import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  Grid,
  Box,
  Paper,
  TableContainer,
  Table,
  TableCell,
  TableRow,
  TableHead,
  TableBody,
  CircularProgress,
} from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";

import * as actions from "./actions";
import moment from "moment";
import DeleteIcon from "@material-ui/icons/Delete";
import {
  getCurrentUserId,
  toastError,
  toastSuccess,
} from "../../../utils";
import CustomPagination from "../../../components/Common/CustomPagination";
import CustomConfirmModal from "../../../components/Common/CustomConfirmModal";
import CustomAddModal from "../../../components/Common/CustomAddModal";

import _ from "lodash";
import SearchBar from "../../../common/Search";
import AddUpdateComplaints from "./AddUpdateComplaints";
import CustomTabs from "../../../common/Tabs";

const initialSearchType = {
  type: "",
  saveLabel: "",
  name: "",
  firstLoadPort: "",
  lastDischargePort: "",
  loadQuantity: "",
  createdDate: "",
};

function Supportinformation(props) {
  const { loader = false, setLoader = () => { } } = props;

  const [value, setValue] = useState(1);
  const [open, setOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const [savedResults, setSavedResults] = useState([]);
  const [isAdminView, setshowStatus] = useState(false);
  const [searchType, setSearchType] = useState({ ...initialSearchType });

  const [singleResults, setSingleResults] = useState({});

  const [myFilters, setMyFilters] = useState({
    offset: 1,
    limit: 50,
  });
  const [hasFetched, setHasFetched] = useState(false);

  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState({});

  // const organizationId = getCurrentUserOrganizationId();
  const addDetailsModalRef = useRef();

  const [searchValue, setSearchValue] = useState("");
  const onSearchVessel = (search) => {
    getAllSavedResults(search);
  };
  const delaySearch = useCallback(
    _.debounce((data) => onSearchVessel(data), 500),
    []
  );
  const onSearchChange = (e) => {
    setSearchValue(e.target.value);
    delaySearch(e.target.value);
  };
  useEffect(() => {
    getAllSavedResults();
  }, []);
  const onCloseModal = () => {
    setOpen(false);
    setIsEdit(false);
  };
  const getAllSavedResults = async (search) => {
    setLoader(true);
    await actions
      .getAllComplaints({ userId: getCurrentUserId(), search: search })
      .then((res) => {
        setLoader(false);
        setHasFetched(true);
        setSavedResults(res?.data?.list || []);
        setMyFilters({
          totalPages: res?.data?.totalItems,
          offset: res?.data?.currentPage,
          pageCount: res?.data?.totalPages,
          limit: res?.data?.perPage,
        });
      })
      .catch((err) => {
        setLoader(false);
        setHasFetched(true);
        toastError(err?.data?.message);
      });
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setSearchType({ ...initialSearchType });
  };

  const onClickDeletAddress = (id) => {
    setDeleteId(id);
    setDeleteModal(true);
  };

  const onChangeMyPagination = (type = "") => {
    let newMyFilters = {};
    if (type === "inc") {
      newMyFilters = { ...myFilters, offset: myFilters.offset + 1 };
    } else if (type === "first") {
      newMyFilters = { ...myFilters, offset: 1 };
    } else {
      if (myFilters.offset === 1) return;
      newMyFilters = { ...myFilters, offset: myFilters.offset - 1 };
    }
    setLoader(true);
    actions
      .getComplaints({ ...newMyFilters, userId: getCurrentUserId() })
      .then((res) => {
        setLoader(false);
        setMyFilters({
          totalPages: res?.data?.totalItems,
          offset: res?.data?.currentPage,
          pageCount: res?.data?.totalPages,
          limit: res?.data?.perPage,
        });
        setSavedResults(
          (res?.data?.list &&
            Array.isArray(res?.data?.list) &&
            res?.data?.list) ||
          []
        );
      })
      .catch((err) => {
        setLoader(false);
      });
  };

  const onDeleteAddress = () => {
    setLoader(true);
    actions
      .deleteComplaints(deleteId)
      .then((res) => {
        toastSuccess("Result deleted successfully");
        setDeleteModal(false);
        setDeleteId("");
        getAllSavedResults();
      })
      .catch((err) => {
        toastError();
        setLoader(false);
      });
  };
  const onSubmitConfirm = () => {
    if (addDetailsModalRef.current.onSubmitQuery) {
      addDetailsModalRef.current.onSubmitQuery();
    }
  };

  const onClickEditAddress = async (item) => {
    setLoader(true);
    setshowStatus(true);
    await actions
      .getSingleComplaints({ complaintsId: item?._id })
      .then((res) => {
        setSingleResults(res?.data || {});
        setIsEdit(true);
        setLoader(false);
        setOpen(true);
      })
      .catch((err) => {
        setLoader(false);
        toastError(err?.data?.message);
      });
  };

  return (
    <Grid container alignContent="flex-start" className="min-h-[calc(100vh-106px)]">
      <Grid item xs={12}>
        <div className="flex flex-wrap items-center justify-between gap-2 mb-2">
          <CustomTabs active={value} onChange={handleChange} tabs={[{ label: "All Complaints", key: 1 }]} />
          <div className="desktop-searchbar">
            <SearchBar
              placeholder={
                "Search title, page, email, mobile or status"
              }
              setSearchValue={onSearchChange}
              searchValue={searchValue}
            />
          </div>
        </div>
        <div className="mobile-searchbar">
          <SearchBar
            isMobile
            placeholder="Search title, page, email, mobile or status"
            setSearchValue={onSearchChange}
            searchValue={searchValue}
          />
        </div>
      </Grid>

      <Grid item xs={12}>
        <Box>
          <TableContainer component={Paper} className="!rounded-none !shadow-sm overflow-x-auto scroll-thin">
            <Table className="universal-table">
              <TableHead>
                <TableRow>
                  <TableCell>No.</TableCell>
                  <TableCell>Title</TableCell>
                  <TableCell>Page</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>Mobile No.</TableCell>
                  <TableCell>Created on</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell className="!w-24 !min-w-[96px]">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loader ? (
                  <TableRow>
                    <TableCell colSpan={8} align="center" className="!bg-white">
                      <Box display="flex" justifyContent="center" alignItems="center" height="440px">
                        <CircularProgress size={24} aria-label="Loading complaints" />
                      </Box>
                    </TableCell>
                  </TableRow>
                ) : Array.isArray(savedResults) && savedResults.length ? (
                  savedResults.map((item, index) => {
                    return (
                      <TableRow
                        key={index}
                        className="h-7 cursor-pointer hover:bg-slate-100"
                        onDoubleClick={() => onClickEditAddress(item)}
                      >
                        <TableCell>{((myFilters.offset || 1) - 1) * (myFilters.limit || 50) + index + 1}</TableCell>
                        <TableCell>{item?.title}</TableCell>
                        <TableCell>{item?.pageName}</TableCell>
                        <TableCell>{item?.emailAddress || ""}</TableCell>
                        <TableCell>{item?.mobileNumber || ""}</TableCell>
                        <TableCell>
                          {moment(item?.createdDate).format("DD/MMM/yyyy")}
                        </TableCell>
                        <TableCell>
                          {item?.current_status ? (
                            <span className={`tb-status capitalize ${item.current_status === "resolved" ? "tb-status-success" : item.current_status === "in-progress" ? "tb-status-blue" : "tb-status-warning"}`}>
                              {item.current_status.replace(/-/g, " ")}
                            </span>
                          ) : "—"}
                        </TableCell>
                        <TableCell>
                          <div className="flex items-center justify-center gap-1">
                            <button
                              type="button"
                              title="View complaint"
                              aria-label={`View complaint ${item?.title || index + 1}`}
                              className="h-7 w-7 inline-flex items-center justify-center text-[#313C4C] hover:bg-slate-200 transition-colors"
                              onClick={() => onClickEditAddress(item)}
                            >
                              <VisibilityIcon className="!text-[14px]" />
                            </button>
                            <button
                              type="button"
                              title="Delete complaint"
                              aria-label={`Delete complaint ${item?.title || index + 1}`}
                              className="h-7 w-7 inline-flex items-center justify-center text-rose-600 hover:bg-rose-50 transition-colors"
                              onClick={() => onClickDeletAddress(item?._id)}
                            >
                              <DeleteIcon className="!text-[14px]" />
                            </button>
                          </div>
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : hasFetched ? (
                  <TableRow>
                    <TableCell colSpan="8" align="center" className="!bg-white">
                      No complaints found.
                    </TableCell>
                  </TableRow>
                ) : null}
              </TableBody>
            </Table>
            {myFilters?.totalPages > myFilters?.limit && (
              <CustomPagination
                onChangePagination={onChangeMyPagination}
                filters={myFilters}
                totalPage={myFilters?.totalPages}
              />
            )}
          </TableContainer>
        </Box>
      </Grid>

      <CustomConfirmModal
        open={deleteModal}
        handleClose={() => setDeleteModal(false)}
        message="Are you sure you want to delete this complaint?"
        onSubmitConfirm={onDeleteAddress}
        type="warning"
        confirmText="DELETE"
        cancelText="Cancel"
        note="This action cannot be undone."
      />

      <CustomAddModal
        open={open}
        title={isEdit ? "Update Complaint" : "Add Complaint"}
        maxWidth="md"
        saveLabel={isEdit ? "Update" : "Create"}
        handleClose={onCloseModal}
        onSubmitConfirm={onSubmitConfirm}
      >
        <AddUpdateComplaints
          ref={addDetailsModalRef}
          setLoader={setLoader}
          onCloseModal={onCloseModal}
          getAllSavedResults={getAllSavedResults}
          singleResults={singleResults}
          isEdit={isEdit}
          isAdminView={isAdminView}
        />
      </CustomAddModal>
    </Grid>
  );
}

export default Supportinformation;
